import Reflux from 'reflux';
import { WebinarActions, AppActions } from 'actions';
import SteelCompass from 'services/SteelCompass';

const WebinarStore = Reflux.createStore({
  listenables: [WebinarActions],
  data: {
    url: null,
    loading: true
  },

  getInitialState() {
    return this.data;
  },

  initWebinar(id, isWebinar, isHost, addHostKey, useCoursioKeys) {
    return SteelCompass.request('vendor/xroom', 'init', {
      id,
      isWebinar,
      isHost,
      addHostKey,
      useCoursioKeys,
    }).then(
      (data) => {
        this.data.loading = true;
        this.trigger(this.data);
        WebinarActions.initComplete(data.url)
      },
      error => {
        AppActions.genericError(error);
      }
    );
  },

  initComplete(url) {
    this.data = {
      url,
      loading: false,
    };
    this.trigger(this.data);
  }

});

export default WebinarStore;



// WEBPACK FOOTER //
// ./src/js/stores/Webinar.js